export enum ModalStates {
  VIEW= 'view',
  EDIT = 'edit',
  ADD = 'add'
}
